import script from "./SalesVariants.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesVariants.vue?vue&type=script&setup=true&lang=js"

import "./SalesVariants.vue?vue&type=style&index=0&id=2076548e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2076548e"]])

export default __exports__